export default {
  high: 'basic-primary-new-blue',
  medium: 'Interface-Eighth',
  low: 'text-secondary',
}
